<a [href]="orcidUrl$ | async"
   role="link"
   target="_blank"
   rel="noopener noreferrer"
   class="orcid-link">
  <img placement="top"
       [ngbTooltip]="orcidTooltipTemplate"
       class="orcid-icon"
       alt="ORCID {{ orcidTooltip }}"
       [src]="authenticatedTimestamp ? 'assets/images/orcid.logo.icon.svg': 'assets/images/orcid.logo.unauth.icon.svg'"
       data-test="orcidIcon"/>
</a>

<ng-template #orcidTooltipTemplate>
    <span class="text-muted">{{ orcidTooltip }}</span>
</ng-template>
